// Copyright (c) 2017 Deere & Company

import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import t from 'tcomb';

const MachineStatusUpdates = t.list(StatusChange, 'MachineStatusUpdates');

export const getDefaultState = () => new MachineStatusUpdates([]);

export default MachineStatusUpdates;



// WEBPACK FOOTER //
// ./src/product/machine-status-update/state/machine-status-updates.js